<template>
  <a-avatar
    v-if="avatarUrl"
    :src="avatarUrl||''"
    class="icon-avatar"
  />
  <a-avatar
    v-else
    class="icon-avatar"
  >
    <template #icon>
      <UserOutlined />
    </template>
  </a-avatar>
</template>

<script>
import { UserOutlined } from '@ant-design/icons-vue'

export default {
  components: {
    UserOutlined
  },
  props: {
    avatarUrl: {
      type: [String, Boolean],
      default: undefined
    }
  }
}
</script>

<style lang="less" scoped>
.icon-avatar {
  display: block;
  background-color: #0085FF;

  span {
    font-size: 18px;
  }
}
</style>
